// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorMembers = (client) => ({
    /**
     * `DELETE /vendor/members/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteMemberById
     * @source packages/modules/b2c-core/src/api/vendor/members/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/members/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/members/:id/sales-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorRevokeMemberSalesManager
     * @source packages/modules/b2c-core/src/api/vendor/members/[id]/sales-manager/route.ts
     */
    deleteSalesManager: (id, body, query, headers) => client.fetch(buildPath("/vendor/members/:id/sales-manager", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/members`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListMembers
     * @source packages/modules/b2c-core/src/api/vendor/members/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/members", { method: "GET", query, headers }),
    /**
     * `GET /vendor/members/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetMemberById
     * @source packages/modules/b2c-core/src/api/vendor/members/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/members/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/members/:id/sales-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetMemberSalesManager
     * @source packages/modules/b2c-core/src/api/vendor/members/[id]/sales-manager/route.ts
     */
    retrieveSalesManager: (id, query, headers) => client.fetch(buildPath("/vendor/members/:id/sales-manager", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/members/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateMemberById
     * @source packages/modules/b2c-core/src/api/vendor/members/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/members/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/members/:id/sales-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAssignMemberSalesManager
     * @source packages/modules/b2c-core/src/api/vendor/members/[id]/sales-manager/route.ts
     */
    updateSalesManager: (id, body, query, headers) => client.fetch(buildPath("/vendor/members/:id/sales-manager", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=members.js.map